export const globalCss = {
  body: {
    colorPalette: 'brand',
    fontFamily: "'Roboto', sans-serif",
  },
  html: {
    fontFamily: "'Roboto', sans-serif",
  },
};
